module.exports = __webpack_public_path__ + "8e3a978b702707b9d4726a3e63eb1e58.png";